var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"owl-carousel owl-theme"},_vm._l((_vm.items),function(item){return _c('div',{key:item.id,staticClass:"item"},[_c('div',{domProps:{"innerHTML":_vm._s(item.htmlContent)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }